import {ChangeDetectionStrategy, Component, inject, OnDestroy, ViewEncapsulation} from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet} from '@angular/router';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { UiService } from '@shared/services/ui.service';
import {filter, Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SpinnerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export default class AppComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  uiService = inject(UiService);
  protected loading = this.uiService.getLoading();
  private router = inject(Router);

  matIconRegistry = inject(MatIconRegistry);
  domSanitizer = inject(DomSanitizer);

  constructor() {
    this.setupIconRegistry();
    this.setupRouterEvents();
  }

  private setupIconRegistry(): void {
    this.matIconRegistry.addSvgIcon('custom-close', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/custom-close.svg'));
    this.matIconRegistry.addSvgIcon('custom-more', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/more.svg'));
    this.matIconRegistry.addSvgIcon('custom-warning', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/warning.svg'));
    this.matIconRegistry.addSvgIcon('tick-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/tick-circle.svg'));
    this.matIconRegistry.addSvgIcon('info-polygon', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/info-polygon.svg'));
    this.matIconRegistry.addSvgIcon('copy', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/copy.svg'));
    this.matIconRegistry.addSvgIcon('copy-2', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/copy-2.svg'));
    this.matIconRegistry.addSvgIcon('chevron-left', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/chevron-left.svg'));
    this.matIconRegistry.addSvgIcon('arrow-right', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-right.svg'));
    this.matIconRegistry.addSvgIcon('arrow-left', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-left.svg'));
    this.matIconRegistry.addSvgIcon('arrow-down', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-down.svg'));
    this.matIconRegistry.addSvgIcon('info-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/info-circle.svg'));
    this.matIconRegistry.addSvgIcon('close-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/close-circle.svg'));
    this.matIconRegistry.addSvgIcon('chevron-down', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/chevron-down.svg'));
    this.matIconRegistry.addSvgIcon('add', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/add.svg'));
    this.matIconRegistry.addSvgIcon('more-action', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/more-action.svg'));
  }

  private setupRouterEvents(): void {
    this.router.events.pipe(
      takeUntil(this.destroy$),
      filter(event =>
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      )
    ).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.onRoutingStart();
      } else {
        this.onRoutingStop();
      }
    });
  }


  onRoutingStart(): void {
    this.uiService.setLoading(true);
  }

  onRoutingStop(): void {
    this.uiService.setLoading(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
